import { render, staticRenderFns } from "./Greeting.vue?vue&type=template&id=27dcebab&"
import script from "./Greeting.vue?vue&type=script&lang=js&"
export * from "./Greeting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports